// Section 17 and 18: Ask on shortage policy. On: the season pauses on the shortage dialog when
// someone unpinned falls below the floor (always under Manual). Off applies the policy silently
// and reports afterwards. Default: config.policies.defaults.askOnShortage.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { definePolicy, noModifiers } from '../../core/registry';

export function askOnShortage(config: Config) {
  return definePolicy({
    id: 'askOnShortage',
    label: 'Ask on shortage',
    section: 'S18',
    group: 'rations',
    options: [true, false],
    default: config.policies.defaults.askOnShortage,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, on) {
      return [
        {
          key: on ? 'policy.askOnShortage.on' : 'policy.askOnShortage.off',
          params: { floor: Math.round(ctx.state.policies.foodFloor * 100) },
        },
      ];
    },
    validate: noProblem,
  });
}
